import { render, staticRenderFns } from "./box-chat.vue?vue&type=template&id=7c8c4056&"
import script from "./box-chat.vue?vue&type=script&lang=js&"
export * from "./box-chat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports